import { render, staticRenderFns } from "./CanvasHintsPresenting.vue?vue&type=template&id=15a7ccac&scoped=true"
import script from "./CanvasHintsPresenting.vue?vue&type=script&lang=js"
export * from "./CanvasHintsPresenting.vue?vue&type=script&lang=js"
import style0 from "./CanvasHintsPresenting.vue?vue&type=style&index=0&id=15a7ccac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7ccac",
  null
  
)

export default component.exports